export const LOADING_PORTAL_ID = 'loading-portal-root'
